import { render, staticRenderFns } from "./potencial-pecas.vue?vue&type=template&id=5ea052e5&scoped=true&"
import script from "./potencial-pecas.vue?vue&type=script&lang=js&"
export * from "./potencial-pecas.vue?vue&type=script&lang=js&"
import style0 from "./potencial-pecas.vue?vue&type=style&index=0&id=5ea052e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea052e5",
  null
  
)

export default component.exports